<template>
    <div>
        <full-background-page v-if="!workplace">
            <div class="container wrapper">
                <div class="card card-body shadow p-5" style="flex-grow: 0;">
                    <h1 class="font-size-xl mb-5">Var befinner du dig?</h1>
                    <div>
                        <select class="form-control" v-model="new_workplace">
                            <option value="">--- Välj arbetsplats ---</option>
                            <option v-for="(workplace, i_idx) in workplaces" :key="'l-' + i_idx" :value="workplace.StoreID">{{ workplace.StoreName }}</option>
                        </select>

                        <button v-touch:start="setWorkplace" v-touch-options="{ touchClass: 'active' }" class="btn btn-success btn-block mt-5" :disabled="!new_workplace">
                            <div class="font-size-lg">OK</div>
                        </button>
                    </div>
                </div>
            </div>
        </full-background-page>
        <full-background-page v-else-if="debug">
            <div class="container wrapper">
                <div class="card card-body shadow p-5" style="flex-grow: 0;">
                    <h1 class="font-size-xl mb-5">ADMIN AREA</h1>
                    <p class="py-3">Appverison: {{ app_version }}</p>
                    <div class="mb-5">
                        <button @click="reload()" class="btn btn-info btn-block">
                            Ladda om app
                        </button>
                    </div>
                    <div class="mb-3">
                        <label for="input-workplace">Arbetsplats</label>
                        <select id="input-workplace" class="form-control" v-model="new_workplace">
                            <option value="">--- Välj arbetsplats ---</option>
                            <option v-for="(workplace, i_idx) in workplaces" :key="'l-' + i_idx" :value="workplace.StoreID">{{ workplace.StoreName }}</option>
                        </select>
                    </div>
                    <div class="row mt-5">
                        <div class="col-6">
                            <button @click="debug = false" class="btn btn-secondary btn-block">
                                <div class="font-size-md">AVBRYT</div>
                            </button>
                        </div>
                        <div class="col-6">
                            <button v-touch:start="saveDebug" v-touch-options="{ touchClass: 'active' }" class="btn btn-success btn-block" :disabled="!new_workplace">
                                <div class="font-size-md">OK</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </full-background-page>
        <full-background-page v-else-if="user">
            <div class="container wrapper">
                <div class="card card-body shadow p-5" style="flex-grow: 0;">
                    <h1 class="font-size-xl mb-5">{{ welcome_phrase }}, <nobr>{{ user.name }}!</nobr></h1>
                    <div v-if="user.latest_timecare && !user.latest_timecare.TimeOUT">
                        <p>Din senaste incheckning: {{ user.latest_timecare.TimeIN }}</p>
                        <div class="text-center" style="margin-top: 50px;">
                            <div class="card card-body text-center py-4 px-5">
                                <h1 class="font-size-xl">Raster</h1>
                                <p class="py-3 font-weight-bold">{{ break_minutes }} minuter</p>
                                <div>
                                    <button type="button" class="btn btn-white" v-touch:start="subBreakMinutes(15)" v-touch-options="{ touchClass: 'active' }" :disabled="request_loading">-15</button>
                                    <button type="button" class="btn btn-white" v-touch:start="addBreakMinutes(15)" v-touch-options="{ touchClass: 'active' }" :disabled="request_loading">+15</button>
                                </div>
                            </div>
                            <button v-touch:start="checkOut" v-touch-options="{ touchClass: 'active' }" class="btn btn-danger btn-block mt-5" :disabled="request_loading">
                                <div v-if="request_loading" style="height: 67px; display: flex; justify-content: center; align-items: center;">
                                    <div class="loader-white" style="font-size: 8px;">Loading...</div>
                                </div>
                                <div v-else>
                                    <div class="font-size-lg">CHECKA UT</div>
                                    <div class="font-weight-400 mt-2">(När du slutar)</div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="user.latest_timecare">Din senaste utcheckning: {{ user.latest_timecare.TimeOUT }}</div>
                        <div class="text-center">
                            <button v-touch:start="checkIn" v-touch-options="{ touchClass: 'active' }" class="btn btn-success btn-block mt-5" :disabled="request_loading">
                                <div v-if="request_loading" style="height: 67px; display: flex; justify-content: center; align-items: center;">
                                    <div class="loader-white" style="font-size: 8px;">Loading...</div>
                                </div>
                                <div v-else>
                                    <div class="font-size-lg" style="margin-bottom: 5px;">CHECKA IN</div>
                                    <div class="font-weight-400 mt-2">(När du börjar)</div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <button v-touch:start="logout" v-touch-options="{ touchClass: 'active' }" class="btn btn-secondary btn-block mt-3">
                        <div class="font-size-lg">AVBRYT</div>
                    </button>
                </div>
            </div>
        </full-background-page>
        <full-background-page v-else>
            <div class="container wrapper">
                <keypad ref="keypad" @input="login" @clear="clear" style="margin: 0 auto; max-width: 300px;" :busy="request_loading"></keypad>
            </div>
        </full-background-page>
    </div>
</template>

<script>
import Keypad from './components/Keypad';
import FullBackgroundPage from './components/FullBackgroundPage';
import axios from 'axios';
import Cookies from 'js-cookie'
import Vue from 'vue';

export default {
    name: 'App',
    components: {
        Keypad,
        FullBackgroundPage
    },
    data: () => ({
        request_loading: false,
        timer: null,
        debug: false,
        user: null,
        break_minutes: 0,
        welcome_phrase: 'Välkommen',
        new_workplace: '',
        workplace: '',
        workplaces: [],
    }),
    async created() {
        const workplace = Cookies.get('workplace');
        if (workplace) {
            this.workplace = workplace;
        }
        await this.loadWorkplaces();
    },
    async mounted() {
        this.timer = setInterval(this.activityCountdown, 5000);
    },
    beforeDestroy: function () {
        clearInterval(this.timer);
    },
    watch: {
        workplace: function (workplace) {
            Cookies.set('workplace', workplace, { expires: 30 })
        }
    },
    methods: {
        login(code) {
            this.setWelcomePhrase();
            if(!this.request_loading) {
                this.request_loading = true;
                axios.post('/api/timecare/login', { code: code })
                    .then((response) => {
                        this.request_loading = false;
                        this.user = response.data.user;
                        if (this.user.latest_timecare && this.user.latest_timecare.TimeIN) {
                            const t = this.user.latest_timecare.TimeIN.split(/[- :]/);
                            const startDate = new Date();
                            startDate.setFullYear(t[0]);
                            startDate.setMonth(t[1] - 1);
                            startDate.setDate(t[2]);
                            startDate.setHours(t[3]);
                            startDate.setMinutes(t[4]);
                            startDate.setSeconds(t[5]);
                            const endDate = new Date();
                            const diffInMinutes = Math.floor(Math.abs(endDate - startDate) / 1000 / 60);
                            if (diffInMinutes > ((60 * 7) - 5)) {
                                this.break_minutes = 60;
                            } else if (diffInMinutes > ((60 * 5) - 5)) {
                                this.break_minutes = 30;
                            } else if (diffInMinutes > ((60 * 4) - 5)) {
                                this.break_minutes = 15;
                            } else {
                                this.break_minutes = 0;
                            }
                        }
                    })
                    .catch((error) => {
                        this.request_loading = false;
                        const { data } = error.response;
                        let message = 'Något gick fel...';
                        if (data.message) {
                            message = data.message;
                        }
                        this.$refs.keypad.showMessage(message, 'danger');
                    });
            }
            this.activity();
        },
        clear(code) {
            if (code === '0000') {
                console.log('RELOAD CALLED');
                this.$refs.keypad.showMessage('RELOAD CALLED', 'info').then(() => {
                    this.reload();
                });
            } else if (code === '1959') {
                console.log('DEBUG ACTIVATED');
                this.new_workplace = this.workplace;
                this.debug = true;
            }
        },
        logout() {
            this.user = null;
            this.break_minutes = 0;
        },
        checkIn() {
            this.activity();
            if(!this.request_loading) {
                this.request_loading = true;
                axios.post('/api/timecare/' + this.user.id + '/checkin', { code: this.user.code, workplace: this.workplace })
                    .then(async (response) => {
                        this.request_loading = false;
                        await this.logout();
                        if (response.data.message) {
                            await this.$refs.keypad.showMessage(response.data.message, 'success');
                        }
                    })
                    .catch((error) => {
                        this.request_loading = false;
                        const { data } = error.response;
                        let message = 'Något gick fel...';
                        if (data.message) {
                            message = data.message;
                        }
                        Vue.swal({
                            title: 'Error!',
                            text: message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            confirmButtonClass: 'btn btn-primary'
                        });
                    });
            }
        },
        checkOut() {
            this.activity();
            if(!this.request_loading) {
                this.request_loading = true;
                axios.post('/api/timecare/' + this.user.id + '/checkout', { code: this.user.code, break_minutes: this.break_minutes, workplace: this.workplace })
                    .then(async (response) => {
                        this.request_loading = false;
                        await this.logout();
                        if (response.data.message) {
                            await this.$refs.keypad.showMessage(response.data.message, 'success');
                        }
                    })
                    .catch((error) => {
                        this.request_loading = false;
                        const { data } = error.response;
                        let message = 'Något gick fel...';
                        if (data.message) {
                            message = data.message;
                        }
                        Vue.swal({
                            title: 'Error!',
                            text: message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            confirmButtonClass: 'btn btn-primary'
                        });
                    });
            }
        },
        addBreakMinutes(minutes) {
            return (direction, event) => {
                if(!this.request_loading) {
                    this.break_minutes += minutes;
                }
                this.activity();
            }
        },
        subBreakMinutes(minutes) {
            return (direction, event) => {
                if(!this.request_loading) {
                    if (this.break_minutes - minutes > 0) {
                        this.break_minutes -= minutes;
                    } else {
                        this.break_minutes = 0;
                    }
                }
                this.activity();
            }
        },
        setWelcomePhrase() {
            const date = new Date();
            const time = date.getHours();
            if (time >= 18) {
                this.welcome_phrase = 'God kväll';
            } else if (time >= 13) {
                this.welcome_phrase =  'God eftermiddag';
            } else if (time >= 11) {
                this.welcome_phrase =  'God middag';
            } else if (time >= 9) {
                this.welcome_phrase =  'God förmiddag';
            } else {
                this.welcome_phrase =  'God morgon';
            }
        },
        activityCountdown() {
            if (this.user) {
                if (this.countdown <= 0) {
                    this.logout();
                } else {
                    this.countdown = this.countdown - 5;
                }
            }
        },
        activity() {
            this.countdown = 30;
        },
        setWorkplace() {
            this.workplace = this.new_workplace;
        },
        saveDebug() {
            this.debug = false;
            this.setWorkplace();
        },
        async loadWorkplaces() {
            await axios.get('/api/workplaces')
                .then((response) => {
                    this.workplaces = response.data;
                });
        },
        reload() {
            location.reload();
        }
    },
    computed: {
        app_version: function() {
            return process.env.MIX_APP_VERSION;
        }
    }
}
</script>
